import styled from '@emotion/styled';
import type React from 'react';

const PreviewContainer = styled.div`
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
`;

const PreviewTitle = styled.div`
  font-weight: 600;
  margin-bottom: 16px;
  color: #495057;
  font-size: 16px;
`;

const JsonContainer = styled.div`
  background-color: white;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 16px;
`;

const JsonDisplay = styled.pre`
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 12px;
  overflow-x: auto;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 12px;
  line-height: 1.4;
  margin: 0;
  max-height: 400px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 20px;
  color: #6c757d;
  font-style: italic;
`;

interface DataPreviewProps {
  data: unknown;
  title?: string;
}

const DataPreview: React.FC<DataPreviewProps> = ({ data, title = 'Data Preview' }) => {
  if (!data || (Array.isArray(data) && data.length === 0)) {
    return (
      <PreviewContainer>
        <PreviewTitle>{title}</PreviewTitle>
        <EmptyState>No data to display</EmptyState>
      </PreviewContainer>
    );
  }

  return (
    <PreviewContainer>
      <PreviewTitle>{title}</PreviewTitle>
      <JsonContainer>
        <JsonDisplay>{JSON.stringify(data, null, 2)}</JsonDisplay>
      </JsonContainer>
    </PreviewContainer>
  );
};

export default DataPreview;
